import { Component, OnInit } from '@angular/core';
import { SettingsService } from 'src/app/shared/services/settings.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    templateUrl: './settings-administration.component.html',
    styleUrls: ['./settings-administration.component.scss'],
    standalone: false
})
export class SettingsAdministrationComponent implements OnInit {

    public openAiConfigured = false;
    public openAiApiKey = '';
    public saving = false;
    public falConfigured = false;
    public falEnvFallback = false;
    public falApiKey = '';
    public falSaving = false;

    constructor(private settingsService: SettingsService, private toastrService: ToastrService) { }

    async ngOnInit(): Promise<void> {
        this.openAiConfigured = await this.settingsService.getOpenAiStatus();
        const fal = await this.settingsService.getFalStatus();
        this.falConfigured = fal.configured;
        this.falEnvFallback = fal.envFallback;
    }

    public async saveFalApiKey(): Promise<void> {
        if (!this.falApiKey.trim()) return;
        this.falSaving = true;
        try {
            const res = await this.settingsService.setFalApiKey(this.falApiKey);
            if (res.status == "ok") {
                this.toastrService.success($localize`:@@globalSaved:Gespeichert!`);
                this.falApiKey = '';
                this.falConfigured = true;
            } else {
                this.toastrService.error($localize`:@@settingsSaveFailed:Das Speichern ist fehlgeschlagen. Versuche es erneut.`);
            }
        } catch (error) {
            this.showSaveError(error);
        } finally {
            this.falSaving = false;
        }
    }

    public async clearFalApiKey(): Promise<void> {
        const res = await this.settingsService.clearFalApiKey();
        if (res.status == "ok") {
            this.toastrService.success($localize`:@@globalSaved:Gespeichert!`);
            this.falConfigured = false;
        } else {
            this.toastrService.error($localize`:@@settingsSaveFailed:Das Speichern ist fehlgeschlagen. Versuche es erneut.`);
        }
    }

    public async saveOpenAiApiKey(): Promise<void> {
        if (!this.openAiApiKey) return;
        this.saving = true;
        try {
            const res = await this.settingsService.setOpenAiApiKey(this.openAiApiKey);
            if (res.status == "ok") {
                this.toastrService.success($localize`:@@globalSaved:Gespeichert!`);
                this.openAiApiKey = '';
                this.openAiConfigured = true;
            } else {
                this.toastrService.error($localize`:@@settingsSaveFailed:Das Speichern ist fehlgeschlagen. Versuche es erneut.`);
            }
        } catch (error) {
            this.showSaveError(error);
        } finally {
            this.saving = false;
        }
    }

    public async clearOpenAiApiKey(): Promise<void> {
        const res = await this.settingsService.clearOpenAiApiKey();
        if (res.status == "ok") {
            this.toastrService.success($localize`:@@globalSaved:Gespeichert!`);
            this.openAiConfigured = false;
        } else {
            this.toastrService.error($localize`:@@settingsSaveFailed:Das Speichern ist fehlgeschlagen. Versuche es erneut.`);
        }
    }

    // Serverfehler (z. B. fehlendes CIPHER_ENC_KEY) liefen bisher ins Leere: kein Toast, Key nicht gespeichert.
    private showSaveError(error: unknown): void {
        const detail = error instanceof HttpErrorResponse ? error.error?.message : undefined;
        const message = $localize`:@@settingsSaveFailed:Das Speichern ist fehlgeschlagen. Versuche es erneut.`;
        this.toastrService.error(detail ? `${message} (${detail})` : message);
    }

}
